"use client";
import * as React from "react";
import { useEffect, useState } from 'react';
import { getPrograms } from '../../api/programs';
import { getSeccionesAcademicas } from '../../api/secciones_academicas';
import styles from "../../styles/AsignacionProgramasStyles/PantallaDeAsignacionProgramaMateria.module.css";

function ProgramSelector() {
  const [programs, setPrograms] = useState([]);
  const [selectedProgramId, setSelectedProgramId] = useState('');
  const [secciones, setSecciones] = useState([]);
  const [selectedSeccion, setSelectedSeccion] = useState('');

  // Notificar cambio de sección académica al panel de materias
  useEffect(() => {
    try {
      window.dispatchEvent(new CustomEvent('seccion:changed', {
        detail: { id_seccion: selectedSeccion || null }
      }));
    } catch (_) {}
  }, [selectedSeccion]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const data = await getPrograms();
        if (mounted) setPrograms(data);
      } catch (e) {
        console.error('Error cargando programas académicos:', e);
      }
      try {
        const seccs = await getSeccionesAcademicas();
        if (mounted) setSecciones(seccs);
      } catch (e) {
        console.error('Error cargando secciones académicas:', e);
      }
    };
    load();
    const onUpdate = (e) => {
      if (mounted && Array.isArray(e.detail)) setPrograms(e.detail);
    };
    window.addEventListener('programs:updated', onUpdate);
    return () => {
      mounted = false;
      window.removeEventListener('programs:updated', onUpdate);
    };
  }, []);

  const selectedProgram = programs.find(p => String(p.id) === String(selectedProgramId));
  const creditsValue = selectedProgram ? selectedProgram.credits : '—';
  // Derivar periodo y duración del programa seleccionado
  const periodTypeRaw = selectedProgram ? selectedProgram.period : '';
  const periodTypeValue = (() => {
    const val = String(periodTypeRaw || '').toLowerCase();
    if (!val) return '';
    if (val.startsWith('tetra')) return 'tetramestres';
    if (val.startsWith('seme')) return 'semestres';
    if (val.startsWith('trime')) return 'trimestres';
    return 'semestres'; // fallback razonable
  })();
  const periodCountValue = selectedProgram && selectedProgram.duration ? selectedProgram.duration : '';

  // Notificar selección con periodo para otras partes (guardar asignación)
  useEffect(() => {
    if (selectedProgram) {
      try {
        window.dispatchEvent(new CustomEvent('program:selected', { detail: {
          id: selectedProgram.id,
          periodType: periodTypeValue,
          periodRaw: periodTypeRaw,
          duration: periodCountValue
        }}));
      } catch (_) {}
    }
  }, [selectedProgramId, periodTypeValue, periodCountValue]);

  return (
    <section className={styles.programSelectorSection}>
      {/* Fila superior derecha: Previsualizar Mapa Curricular e Institución */}
      <div className={styles.topRightBar}>
        <div className={styles.topButtonsGroup}>
          <button className={styles.previewButton}>
            <img
              src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/3df221dcd09695e0e181b62540db94d64e30a0fc?placeholderIfAbsent=true"
              alt=""
              className={styles.buttonIcon}
            />
            <span>Previsualizar Mapa Curricular</span>
          </button>
        </div>
        <div className={styles.institutionInfo}>
          <span className={styles.institutionLabel}>Institución:</span>
          <span className={styles.institutionName}> Universidad Lux</span>
          <img
            src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/3322a14c36b5c86f9a753059593070ff6b5caea4?placeholderIfAbsent=true"
            alt=""
            className={styles.dropdownIcon}
          />
        </div>
      </div>

      {/* Grid principal de la sección según requerimientos */}
      <div className={styles.programLayoutGrid}>
        {/* Sección Académica - Arriba */}
        <div className={`${styles.fieldGroup} ${styles.seccionArea} ${styles.fixedWidthGroup}`}>
          <label className={styles.fieldLabel}>Sección Académica</label>
          <select
            className={styles.selectField}
            value={selectedSeccion}
            onChange={e => setSelectedSeccion(e.target.value)}
          >
            <option value="">--Selecciona una sección--</option>
            {secciones.map(s => (
              <option key={s.id} value={s.id}>{s.nombre}</option>
            ))}
          </select>
        </div>

        {/* Programa Académico - Abajo */}
        <div className={`${styles.fieldGroup} ${styles.programArea} ${styles.fixedWidthGroup}`}>
          <label className={styles.fieldLabel}>Programa Académico</label>
          <select
            className={styles.selectField}
            value={selectedProgramId}
            onChange={(e) => setSelectedProgramId(e.target.value)}
          >
            <option value="">--Selecciona un programa--</option>
            {programs.map(p => (
              <option key={p.id} value={p.id}>{p.name}</option>
            ))}
          </select>
        </div>

        <div className={styles.creditsArea}>
          <div className={styles.creditsCard}>
            <div className={styles.creditsContent}>
              <p className={styles.creditsLabel}>TOTAL DE CRÉDITOS</p>
                <span className={styles.creditsValue}>{creditsValue}</span>
            </div>
          </div>
        </div>

        <div className={styles.periodArea}>
          <label className={styles.fieldLabel}>Periodo</label>
          <div className={styles.periodControlsRow}>
            <select className={styles.periodSelect} value={periodTypeValue} disabled>
              <option value="tetramestres">Tetramestres</option>
              <option value="semestres">Semestres</option>
              <option value="trimestres">Trimestres</option>
            </select>
            <select className={styles.periodNumberSelect} value={periodCountValue} disabled>
              {Array.from({ length: 12 }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProgramSelector;
